import Vue from 'vue'
import axios from "axios";
import {primeAppToken} from "@/api";
import store from '../store'
import VueCookies from 'vue-cookies'
import {refreshToken} from '@/auth/index'

axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${(VueCookies.get("app_token")?VueCookies.get("app_token").token:null)}`;
axios.defaults.headers.common['AuthPrime'] = primeAppToken;

// 요청 인터셉터 추가
axios.interceptors.request.use(
function (config) {
  // 요청을 보내기 전에 수행할 일
  // ...
  return config;
},
function (error) {
  // 오류 요청을 보내기전 수행할 일
  // ...
  return Promise.reject(error);
});



// 응답 인터셉터 추가
axios.interceptors.response.use(
function (response) { // 응답 데이터를 가공
  store.commit('setBtnLoading',false);
  setAxiosDate()
  return response;
},
function (error) { // 오류 응답을 처리
  store.commit('setBtnLoading',false);

  let originalRequest = error.config

  //토큰오류 일경우  app or dev
  if( (store.state.isApp || store.state.isDev) && error.response && !originalRequest.url.includes('updateToken') && !originalRequest._retry && [400,401].includes(error.response.status) ) {
    originalRequest._retry = true;
    return refreshToken(originalRequest);
  } else {
    setAxiosDate()
    return Promise.reject(error);
  } 
});

function setAxiosDate() {
  //prime user 존재할경우 id > 0
  if(store.state.user.id > 0) {
    VueCookies.set('app_axiosDate', Vue.moment().format('YYYY-MM-DD HH:mm:ss'), store.state.user.ttl * 60 );
  }
}



export default axios;
